import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { TFunction } from "i18next";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { ErrorTypes } from "../../types/errors/errors";
import { getErrorMessage } from "./errorTranslations";
import { createElement } from "react";

export const handleError = (
  error: any,
  t: TFunction
) => {
  const code: ErrorTypes = error?.response?.data?.error ?? ErrorTypes.UNKNOWN;
  const validationErrors = error?.response?.data?.errors;
  const message = getErrorMessage(code, t, undefined, validationErrors);

  const isInvalidParameters = code === ErrorTypes.INVALID_PARAMETERS;

  enqueueSnackbar(message, {
    variant: "error",
    ...(isInvalidParameters && {
      persist: true,
      action: (key) => createElement(
        IconButton,
        { size: "small", onClick: () => closeSnackbar(key), sx: { color: "inherit" } },
        createElement(CloseIcon, { fontSize: "small" })
      ),
    }),
  });

  if (process.env.NODE_ENV === "development") {
    console.error(error);
  }
};